const initState = () => ({
  token: "",
  user: null,
  instructorsList: [],
  register: null,
  prefixList: [
    { id: 1, label: "นาย" },
    { id: 2, label: "นาง" },
    { id: 3, label: "นางสาว" },
    { id: 4, label: "ศาสตราจารย์" },
    { id: 5, label: "ผู้ช่วยศาสตราจารย์" },
    { id: 6, label: "รองศาสตราจารย์" },
    { id: 7, label: "ดร." },
  ],
  breadCrumb: { course: [], subject: [] },
  courseList: [],
  agencyTypeList: [
    { id: 9, label: "เกษตรและอุตสาหกรรมอาหาร" },
    { id: 10, label: "สินค้าอุปโภคบริโภค" },
    { id: 11, label: "ธุรกิจการเงิน" },
    { id: 12, label: "สินค้าอุตสาหกรรม" },
    { id: 13, label: "อสังหาริมทรัพย์และก่อสร้าง" },
    { id: 14, label: "ทรัพยากร" },
    { id: 15, label: "บริการ" },
    { id: 16, label: "เทคโนโลยี" },
    { id: 17, label: "การศึกษา" },
    { id: 18, label: "ภาครัฐ/รัฐวิสาหกิจ" },
    // { id: 1, label: "บริษัทนำเที่ยว" },
    // { id: 2, label: "ชุมชนท่องเที่ยว" },
    // { id: 3, label: "ธุรกิจที่พัก" },
    // { id: 4, label: "มัคคุเทศก์" },
    // { id: 5, label: "สถาบันการศึกษา" },
    // {
    //   id: 6,
    //   label: "หน่วยงานภาครัฐและภาคเอกชนที่เกี่ยวข้องกับแหล่งท่องเที่ยว",
    // },
    // { id: 7, label: "ผู้เข้าประกวดรางวัลอุตสาหกรรมท่องเที่ยวไทย" },
    { id: 8, label: "อื่นๆ" },
  ],
  topicLatest: "",
  haveUserData: true,
});

export default initState;
